import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../../assets/images/no-photo.png'
import _imports_1 from '@/assets/images/adobe.png'
import _imports_2 from '@/assets/images/word.png'


const _hoisted_1 = { id: "home" }
const _hoisted_2 = { for: "search" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M17.5002 17.5002L13.881 13.881M13.881 13.881C14.5001 13.2619 14.9912 12.527 15.3262 11.7181C15.6612 10.9093 15.8337 10.0423 15.8337 9.16684C15.8337 8.29134 15.6612 7.42441 15.3262 6.61555C14.9912 5.80669 14.5001 5.07174 13.881 4.45267C13.2619 3.8336 12.527 3.34252 11.7181 3.00748C10.9093 2.67244 10.0423 2.5 9.16684 2.5C8.29134 2.5 7.42441 2.67244 6.61555 3.00748C5.80669 3.34252 5.07174 3.8336 4.45267 4.45267C3.2024 5.70295 2.5 7.39868 2.5 9.16684C2.5 10.935 3.2024 12.6307 4.45267 13.881C5.70295 15.1313 7.39868 15.8337 9.16684 15.8337C10.935 15.8337 12.6307 15.1313 13.881 13.881Z",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M4 4L16 16",
  stroke: "#079F72",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16 4L4 16",
  stroke: "#079F72",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "infos" }
const _hoisted_9 = {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.5206 3.41016C9.21058 3.41016 6.52058 6.10016 6.52058 9.41016V12.3002C6.52058 12.9102 6.26058 13.8402 5.95058 14.3602L4.80058 16.2702C4.09058 17.4502 4.58058 18.7602 5.88058 19.2002C10.1906 20.6402 14.8406 20.6402 19.1506 19.2002C20.3606 18.8002 20.8906 17.3702 20.2306 16.2702L19.0806 14.3602C18.7806 13.8402 18.5206 12.9102 18.5206 12.3002V9.41016C18.5206 6.11016 15.8206 3.41016 12.5206 3.41016Z",
  "stroke-width": "1.5",
  "stroke-miterlimit": "10",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("path", {
  d: "M14.3699 3.69994C14.0599 3.60994 13.7399 3.53994 13.4099 3.49994C12.4499 3.37994 11.5299 3.44994 10.6699 3.69994C10.9599 2.95994 11.6799 2.43994 12.5199 2.43994C13.3599 2.43994 14.0799 2.95994 14.3699 3.69994Z",
  "stroke-width": "1.5",
  "stroke-miterlimit": "10",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("path", {
  d: "M15.5195 19.5601C15.5195 21.2101 14.1695 22.5601 12.5195 22.5601C11.6995 22.5601 10.9395 22.2201 10.3995 21.6801C9.85953 21.1401 9.51953 20.3801 9.51953 19.5601",
  "stroke-width": "1.5",
  "stroke-miterlimit": "10"
}, null, -1)
const _hoisted_13 = {
  key: 0,
  cx: "20",
  cy: "5",
  r: "5",
  fill: "#A30711",
  stroke: "none"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 1,
  src: _imports_0,
  alt: "Foto de perfil não disponível"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M28 8.66651C28 11.2398 25.9067 13.3332 23.3333 13.3332C20.76 13.3332 18.6667 11.2398 18.6667 8.66651C18.6667 6.09318 20.76 3.99984 23.3333 3.99984C25.9067 3.99984 28 6.09318 28 8.66651ZM25.3333 15.7198C24.6667 15.8932 24 15.9998 23.3333 15.9998C21.3895 15.9963 19.5263 15.2226 18.1518 13.8481C16.7773 12.4736 16.0035 10.6103 16 8.66651C16 6.70651 16.7733 4.93318 18 3.61318C17.758 3.31657 17.4529 3.07767 17.1069 2.9139C16.761 2.75013 16.3828 2.66562 16 2.66651C14.5333 2.66651 13.3333 3.86651 13.3333 5.33318V5.71984C9.37333 6.89318 6.66667 10.5332 6.66667 14.6665V22.6665L4 25.3332V26.6665H28V25.3332L25.3333 22.6665V15.7198ZM16 30.6665C17.48 30.6665 18.6667 29.4798 18.6667 27.9998H13.3333C13.3333 28.7071 13.6143 29.3854 14.1144 29.8855C14.6145 30.3856 15.2928 30.6665 16 30.6665Z" })
  ])
], -1)
const _hoisted_17 = { class: "days" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "Faltam", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "dias", -1)
const _hoisted_20 = { class: "infos" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M18 6L6 18",
      stroke: "white",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M6 6L18 18",
      stroke: "white",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "26",
    height: "26",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M8 2V5M16 2V5M3.5 9.09H20.5M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M8 13H16M8 17H13",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_24 = { class: "days" }
const _hoisted_25 = { class: "infos" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M18 6L6 18",
      stroke: "white",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M6 6L18 18",
      stroke: "white",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { class: "updates" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h1", null, "Suas atualizações", -1)
const _hoisted_31 = { class: "itens" }
const _hoisted_32 = {
  key: 0,
  class: "item skeleton"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("h1", null, "Enviados", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", null, "•••", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("h2", null, "Todos que foram enviados.", -1)
const _hoisted_36 = [
  _hoisted_33,
  _hoisted_34,
  _hoisted_35
]
const _hoisted_37 = {
  key: 1,
  class: "item skeleton"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("h1", null, "Pendentes", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("p", null, "•••", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("h2", null, "Todos que não foram vistos.", -1)
const _hoisted_41 = [
  _hoisted_38,
  _hoisted_39,
  _hoisted_40
]
const _hoisted_42 = {
  key: 2,
  class: "item skeleton"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("h1", null, "Tramitando", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("p", null, "•••", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("h2", null, "Enviados, mas nem todos foram vistos.", -1)
const _hoisted_46 = [
  _hoisted_43,
  _hoisted_44,
  _hoisted_45
]
const _hoisted_47 = {
  key: 3,
  class: "item skeleton"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("h1", null, "Prorrogados", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("p", null, "•••", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("h2", null, "Todos que tiveram datas modificadas.", -1)
const _hoisted_51 = [
  _hoisted_48,
  _hoisted_49,
  _hoisted_50
]
const _hoisted_52 = {
  key: 4,
  class: "item skeleton"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("h1", null, "Em atraso", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("p", null, "•••", -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("h2", null, "Todos que não foram vistos até a data limite.", -1)
const _hoisted_56 = [
  _hoisted_53,
  _hoisted_54,
  _hoisted_55
]
const _hoisted_57 = {
  key: 5,
  class: "item skeleton"
}
const _hoisted_58 = /*#__PURE__*/_createElementVNode("h1", null, "Finalizados", -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("p", null, "•••", -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("h2", null, "Todos que foram vistos e concluídos.", -1)
const _hoisted_61 = [
  _hoisted_58,
  _hoisted_59,
  _hoisted_60
]
const _hoisted_62 = { class: "" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("h1", null, "ÚLTIMOS QUE RECEBEU", -1)
const _hoisted_64 = { class: "list" }
const _hoisted_65 = {
  key: 0,
  class: "itens"
}
const _hoisted_66 = ["onClick"]
const _hoisted_67 = { class: "name" }
const _hoisted_68 = { class: "infos" }
const _hoisted_69 = { key: 0 }
const _hoisted_70 = {
  key: 1,
  class: "itens empty"
}
const _hoisted_71 = /*#__PURE__*/_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"56\" height=\"56\" viewBox=\"0 0 56 56\" fill=\"none\"><path d=\"M21.0003 51.3333H35.0003C46.667 51.3333 51.3337 46.6666 51.3337 35V21C51.3337 9.33329 46.667 4.66663 35.0003 4.66663H21.0003C9.33366 4.66663 4.66699 9.33329 4.66699 21V35C4.66699 46.6666 9.33366 51.3333 21.0003 51.3333Z\" stroke=\"white\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M42 18.0833V33.8333C42 31.2666 39.9 29.1666 37.3333 29.1666H18.6667C16.1 29.1666 14 31.2666 14 33.8333V18.0833C14 15.5166 16.1 13.4166 18.6667 13.4166H37.3333C39.9 13.4166 42 15.5166 42 18.0833Z\" stroke=\"white\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M44.3333 36.75H42\" stroke=\"white\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M14.0003 36.75H11.667\" stroke=\"white\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M42 32.6667V25.6667C42 23.1 39.9 21 37.3333 21H18.6667C16.1 21 14 23.1 14 25.6667V32.6667\" stroke=\"white\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M42 33.8333V36.75H33.8333C33.8333 39.97 31.22 42.5833 28 42.5833C24.78 42.5833 22.1667 39.97 22.1667 36.75H14V33.8333C14 31.2666 16.1 29.1666 18.6667 29.1666H37.3333C39.9 29.1666 42 31.2666 42 33.8333Z\" stroke=\"white\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg><h1>Sem documentos recentes.</h1><p>Quando houver serão mostrados aqui.</p>", 3)
const _hoisted_74 = [
  _hoisted_71
]
const _hoisted_75 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M14.9997 36.6668H24.9997C33.333 36.6668 36.6663 33.3335 36.6663 25.0002V15.0002C36.6663 6.66683 33.333 3.3335 24.9997 3.3335H14.9997C6.66634 3.3335 3.33301 6.66683 3.33301 15.0002V25.0002C3.33301 33.3335 6.66634 36.6668 14.9997 36.6668Z",
    stroke: "#090909",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M26.25 15H13.75",
    stroke: "#090909",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M26.25 25H13.75",
    stroke: "#090909",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_76 = { class: "docs" }
const _hoisted_77 = { key: 0 }
const _hoisted_78 = { class: "title" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("h1", null, "Modelos de documento", -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("p", null, "Sempre que precisar, visualize, baixe ou compartilhe um modelo de documento.", -1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8.91016 19.9201L15.4302 13.4001C16.2002 12.6301 16.2002 11.3701 15.4302 10.6001L8.91016 4.08008",
    "stroke-width": "1.5",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_82 = [
  _hoisted_81
]
const _hoisted_83 = {
  key: 1,
  class: "button inative"
}
const _hoisted_84 = { class: "item" }
const _hoisted_85 = {
  key: 0,
  src: _imports_1,
  alt: "Imagem do tipo de arquivo do documento."
}
const _hoisted_86 = {
  key: 1,
  src: _imports_2,
  alt: "Imagem do tipo de arquivo do documento."
}
const _hoisted_87 = { class: "infos" }
const _hoisted_88 = ["onClick"]
const _hoisted_89 = /*#__PURE__*/_createElementVNode("p", null, "baixar", -1)
const _hoisted_90 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      stroke: "none",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.99984 1.4C10.159 1.4 10.3116 1.46321 10.4241 1.57574C10.5366 1.68826 10.5998 1.84087 10.5998 2V11.2187L13.5758 8.24267C13.6308 8.18372 13.697 8.13644 13.7706 8.10364C13.8442 8.07085 13.9237 8.05321 14.0042 8.05179C14.0848 8.05037 14.1648 8.06519 14.2395 8.09537C14.3142 8.12555 14.3821 8.17046 14.4391 8.22744C14.496 8.28441 14.541 8.35228 14.5711 8.42699C14.6013 8.5017 14.6161 8.58172 14.6147 8.66228C14.6133 8.74285 14.5957 8.8223 14.5629 8.8959C14.5301 8.9695 14.4828 9.03574 14.4238 9.09067L10.4238 13.0907C10.3113 13.203 10.1588 13.2661 9.99984 13.2661C9.84084 13.2661 9.68834 13.203 9.57584 13.0907L5.57584 9.09067C5.51689 9.03574 5.46961 8.9695 5.43682 8.8959C5.40402 8.8223 5.38639 8.74285 5.38497 8.66228C5.38355 8.58172 5.39837 8.5017 5.42854 8.42699C5.45872 8.35228 5.50363 8.28441 5.56061 8.22744C5.61758 8.17046 5.68545 8.12555 5.76016 8.09537C5.83487 8.06519 5.9149 8.05037 5.99546 8.05179C6.07602 8.05321 6.15547 8.07085 6.22907 8.10364C6.30267 8.13644 6.36891 8.18372 6.42384 8.24267L9.39984 11.2187V2C9.39984 1.84087 9.46305 1.68826 9.57558 1.57574C9.6881 1.46321 9.84071 1.4 9.99984 1.4ZM3.33317 13.3333C3.50998 13.3333 3.67955 13.4036 3.80458 13.5286C3.9296 13.6536 3.99984 13.8232 3.99984 14V16C3.99984 16.7387 4.59451 17.3333 5.32784 17.3333H14.6678C14.8429 17.3333 15.0162 17.2988 15.1779 17.2318C15.3396 17.1648 15.4865 17.0666 15.6102 16.9427C15.7339 16.8189 15.832 16.6719 15.8988 16.5101C15.9657 16.3484 16 16.175 15.9998 16V14C15.9998 13.8232 16.0701 13.6536 16.1951 13.5286C16.3201 13.4036 16.4897 13.3333 16.6665 13.3333C16.8433 13.3333 17.0129 13.4036 17.1379 13.5286C17.2629 13.6536 17.3332 13.8232 17.3332 14V16C17.3332 16.707 17.0524 17.3851 16.5526 17.8851C16.0528 18.3852 15.3749 18.6663 14.6678 18.6667H5.32784C4.97795 18.6665 4.63152 18.5974 4.30837 18.4632C3.98521 18.3291 3.69166 18.1326 3.4445 17.8849C3.19733 17.6372 3.00141 17.3433 2.86791 17.0199C2.73442 16.6965 2.66598 16.3499 2.66651 16V14C2.66651 13.8232 2.73674 13.6536 2.86177 13.5286C2.98679 13.4036 3.15636 13.3333 3.33317 13.3333Z"
    })
  ])
], -1)
const _hoisted_91 = [
  _hoisted_89,
  _hoisted_90
]
const _hoisted_92 = ["onClick"]
const _hoisted_93 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "none",
      d: "M15.5799 11.9999C15.5799 13.9799 13.9799 15.5799 11.9999 15.5799C10.0199 15.5799 8.41992 13.9799 8.41992 11.9999C8.41992 10.0199 10.0199 8.41992 11.9999 8.41992C13.9799 8.41992 15.5799 10.0199 15.5799 11.9999Z",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      fill: "none",
      d: "M11.9998 20.2702C15.5298 20.2702 18.8198 18.1902 21.1098 14.5902C22.0098 13.1802 22.0098 10.8102 21.1098 9.40021C18.8198 5.80021 15.5298 3.72021 11.9998 3.72021C8.46984 3.72021 5.17984 5.80021 2.88984 9.40021C1.98984 10.8102 1.98984 13.1802 2.88984 14.5902C5.17984 18.1902 8.46984 20.2702 11.9998 20.2702Z",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_94 = [
  _hoisted_93
]
const _hoisted_95 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8.91016 19.9201L15.4302 13.4001C16.2002 12.6301 16.2002 11.3701 15.4302 10.6001L8.91016 4.08008",
    "stroke-width": "1.5",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_96 = [
  _hoisted_95
]
const _hoisted_97 = {
  key: 1,
  class: "else"
}
const _hoisted_98 = /*#__PURE__*/_createElementVNode("h1", null, "Modelos de documento", -1)
const _hoisted_99 = /*#__PURE__*/_createElementVNode("h2", null, "Nesse espaço estarão todos os modelos de documentos necessários para que você possa desempenhar o seu melhor trabalho. Modelos de oficios, solicitações, requerimentos e outros.", -1)
const _hoisted_100 = [
  _hoisted_98,
  _hoisted_99
]
const _hoisted_101 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_102 = { key: 2 }
const _hoisted_103 = { class: "title" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("h1", null, "Fluxo de documentos", -1)
const _hoisted_105 = /*#__PURE__*/_createElementVNode("p", null, "Sempre que precisar, visualize, baixe ou compartilhe um fluxo de processo de documento.", -1)
const _hoisted_106 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8.91016 19.9201L15.4302 13.4001C16.2002 12.6301 16.2002 11.3701 15.4302 10.6001L8.91016 4.08008",
    "stroke-width": "1.5",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_107 = [
  _hoisted_106
]
const _hoisted_108 = {
  key: 1,
  class: "button inative"
}
const _hoisted_109 = { class: "item" }
const _hoisted_110 = {
  key: 0,
  src: _imports_1,
  alt: "Imagem pdf."
}
const _hoisted_111 = {
  key: 1,
  src: _imports_2,
  alt: "Imagem word."
}
const _hoisted_112 = { class: "infos" }
const _hoisted_113 = ["onClick"]
const _hoisted_114 = /*#__PURE__*/_createElementVNode("p", null, "baixar", -1)
const _hoisted_115 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      stroke: "none",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.99984 1.4C10.159 1.4 10.3116 1.46321 10.4241 1.57574C10.5366 1.68826 10.5998 1.84087 10.5998 2V11.2187L13.5758 8.24267C13.6308 8.18372 13.697 8.13644 13.7706 8.10364C13.8442 8.07085 13.9237 8.05321 14.0042 8.05179C14.0848 8.05037 14.1648 8.06519 14.2395 8.09537C14.3142 8.12555 14.3821 8.17046 14.4391 8.22744C14.496 8.28441 14.541 8.35228 14.5711 8.42699C14.6013 8.5017 14.6161 8.58172 14.6147 8.66228C14.6133 8.74285 14.5957 8.8223 14.5629 8.8959C14.5301 8.9695 14.4828 9.03574 14.4238 9.09067L10.4238 13.0907C10.3113 13.203 10.1588 13.2661 9.99984 13.2661C9.84084 13.2661 9.68834 13.203 9.57584 13.0907L5.57584 9.09067C5.51689 9.03574 5.46961 8.9695 5.43682 8.8959C5.40402 8.8223 5.38639 8.74285 5.38497 8.66228C5.38355 8.58172 5.39837 8.5017 5.42854 8.42699C5.45872 8.35228 5.50363 8.28441 5.56061 8.22744C5.61758 8.17046 5.68545 8.12555 5.76016 8.09537C5.83487 8.06519 5.9149 8.05037 5.99546 8.05179C6.07602 8.05321 6.15547 8.07085 6.22907 8.10364C6.30267 8.13644 6.36891 8.18372 6.42384 8.24267L9.39984 11.2187V2C9.39984 1.84087 9.46305 1.68826 9.57558 1.57574C9.6881 1.46321 9.84071 1.4 9.99984 1.4ZM3.33317 13.3333C3.50998 13.3333 3.67955 13.4036 3.80458 13.5286C3.9296 13.6536 3.99984 13.8232 3.99984 14V16C3.99984 16.7387 4.59451 17.3333 5.32784 17.3333H14.6678C14.8429 17.3333 15.0162 17.2988 15.1779 17.2318C15.3396 17.1648 15.4865 17.0666 15.6102 16.9427C15.7339 16.8189 15.832 16.6719 15.8988 16.5101C15.9657 16.3484 16 16.175 15.9998 16V14C15.9998 13.8232 16.0701 13.6536 16.1951 13.5286C16.3201 13.4036 16.4897 13.3333 16.6665 13.3333C16.8433 13.3333 17.0129 13.4036 17.1379 13.5286C17.2629 13.6536 17.3332 13.8232 17.3332 14V16C17.3332 16.707 17.0524 17.3851 16.5526 17.8851C16.0528 18.3852 15.3749 18.6663 14.6678 18.6667H5.32784C4.97795 18.6665 4.63152 18.5974 4.30837 18.4632C3.98521 18.3291 3.69166 18.1326 3.4445 17.8849C3.19733 17.6372 3.00141 17.3433 2.86791 17.0199C2.73442 16.6965 2.66598 16.3499 2.66651 16V14C2.66651 13.8232 2.73674 13.6536 2.86177 13.5286C2.98679 13.4036 3.15636 13.3333 3.33317 13.3333Z"
    })
  ])
], -1)
const _hoisted_116 = [
  _hoisted_114,
  _hoisted_115
]
const _hoisted_117 = ["onClick"]
const _hoisted_118 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "none",
      d: "M15.5799 11.9999C15.5799 13.9799 13.9799 15.5799 11.9999 15.5799C10.0199 15.5799 8.41992 13.9799 8.41992 11.9999C8.41992 10.0199 10.0199 8.41992 11.9999 8.41992C13.9799 8.41992 15.5799 10.0199 15.5799 11.9999Z",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      fill: "none",
      d: "M11.9998 20.2697C15.5298 20.2697 18.8198 18.1897 21.1098 14.5897C22.0098 13.1797 22.0098 10.8097 21.1098 9.39973C18.8198 5.79973 15.5298 3.71973 11.9998 3.71973C8.46984 3.71973 5.17984 5.79973 2.88984 9.39973C1.98984 10.8097 1.98984 13.1797 2.88984 14.5897C5.17984 18.1897 8.46984 20.2697 11.9998 20.2697Z",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_119 = [
  _hoisted_118
]
const _hoisted_120 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8.91016 19.9201L15.4302 13.4001C16.2002 12.6301 16.2002 11.3701 15.4302 10.6001L8.91016 4.08008",
    "stroke-width": "1.5",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_121 = [
  _hoisted_120
]
const _hoisted_122 = {
  key: 3,
  class: "else"
}
const _hoisted_123 = /*#__PURE__*/_createElementVNode("h1", null, "Fluxo de documentos", -1)
const _hoisted_124 = /*#__PURE__*/_createElementVNode("h2", null, "Nesse espaço estarão todos os fluxos de documentos necessários para que você possa desempenhar o seu melhor trabalho. Modelos de ofícios, solicitações, requerimentos e outros.", -1)
const _hoisted_125 = [
  _hoisted_123,
  _hoisted_124
]
const _hoisted_126 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M21 22.0001H3C2.59 22.0001 2.25 21.6601 2.25 21.2501C2.25 20.8401 2.59 20.5001 3 20.5001H21C21.41 20.5001 21.75 20.8401 21.75 21.2501C21.75 21.6601 21.41 22.0001 21 22.0001ZM19.02 3.48211C17.08 1.54211 15.18 1.49211 13.19 3.48211L11.98 4.69211C11.88 4.79211 11.84 4.95211 11.88 5.09211C12.2625 6.40449 12.9697 7.59923 13.9363 8.56583C14.9029 9.53242 16.0976 10.2397 17.41 10.6221C17.4809 10.6453 17.5568 10.6483 17.6293 10.6306C17.7017 10.6129 17.7678 10.5753 17.82 10.5221L19.02 9.31211C20.01 8.33211 20.49 7.38211 20.49 6.42211C20.5 5.43211 20.02 4.47211 19.02 3.48211ZM15.61 11.5301C15.32 11.3901 15.04 11.2501 14.77 11.0901C14.5507 10.9595 14.3371 10.8193 14.13 10.6701C13.96 10.5601 13.76 10.4001 13.57 10.2401C13.5088 10.1955 13.4519 10.1453 13.4 10.0901C13.07 9.81011 12.7 9.45011 12.37 9.05011C12.34 9.03011 12.29 8.96011 12.22 8.87011C12.12 8.75011 11.95 8.55011 11.8 8.32011C11.6575 8.13203 11.5272 7.93495 11.41 7.73011C11.25 7.46011 11.11 7.19011 10.97 6.91011C10.9492 6.86533 10.9288 6.82033 10.909 6.77511C10.761 6.44211 10.326 6.34511 10.069 6.60211L4.34 12.3311C4.21 12.4611 4.09 12.7111 4.06 12.8811L3.52 16.7111C3.42 17.3911 3.61 18.0311 4.03 18.4611C4.39 18.8111 4.89 19.0011 5.43 19.0011C5.55 19.0011 5.67 18.9911 5.79 18.9711L9.63 18.4311C9.81 18.4011 10.06 18.2811 10.18 18.1511L15.902 12.4301C16.162 12.1701 16.063 11.7251 15.726 11.5801C15.6873 11.5635 15.6486 11.5469 15.61 11.5301Z",
      fill: "white"
    })
  ])
], -1)
const _hoisted_127 = [
  _hoisted_126
]
const _hoisted_128 = /*#__PURE__*/_createElementVNode("h1", null, "Notificações", -1)
const _hoisted_129 = { class: "itens" }
const _hoisted_130 = ["onClick"]
const _hoisted_131 = /*#__PURE__*/_createElementVNode("div", { class: "note-label" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "13",
    height: "13",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M8 2V5M16 2V5M3.5 9.09H20.5M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z",
      stroke: "white",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M15.6947 13.7H15.7037M15.6947 16.7H15.7037M11.9955 13.7H12.0045M11.9955 16.7H12.0045M8.29431 13.7H8.30329M8.29431 16.7H8.30329",
      stroke: "white",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "Lembrete de hoje")
], -1)
const _hoisted_132 = ["innerHTML"]
const _hoisted_133 = { class: "note-date" }
const _hoisted_134 = {
  key: 0,
  class: "empty-notifications"
}
const _hoisted_135 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.5206 3.41016C9.21058 3.41016 6.52058 6.10016 6.52058 9.41016V12.3002C6.52058 12.9102 6.26058 13.8402 5.95058 14.3602L4.80058 16.2702C4.09058 17.4502 4.58058 18.7602 5.88058 19.2002C10.1906 20.6402 14.8406 20.6402 19.1506 19.2002C20.3606 18.8002 20.8906 17.3702 20.2306 16.2702L19.0806 14.3602C18.7806 13.8402 18.5206 12.9102 18.5206 12.3002V9.41016C18.5206 6.11016 15.8206 3.41016 12.5206 3.41016Z",
    stroke: "#D3D3D3",
    "stroke-width": "1.5",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M14.3699 3.69994C14.0599 3.60994 13.7399 3.53994 13.4099 3.49994C12.4499 3.37994 11.5299 3.44994 10.6699 3.69994C10.9599 2.95994 11.6799 2.43994 12.5199 2.43994C13.3599 2.43994 14.0799 2.95994 14.3699 3.69994Z",
    stroke: "#D3D3D3",
    "stroke-width": "1.5",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M15.5195 19.5601C15.5195 21.2101 14.1695 22.5601 12.5195 22.5601C11.6995 22.5601 10.9395 22.2201 10.3995 21.6801C9.85953 21.1401 9.51953 20.3801 9.51953 19.5601",
    stroke: "#D3D3D3",
    "stroke-width": "1.5",
    "stroke-miterlimit": "10"
  })
], -1)
const _hoisted_136 = /*#__PURE__*/_createElementVNode("p", null, "Sem notificações no momento", -1)
const _hoisted_137 = [
  _hoisted_135,
  _hoisted_136
]
const _hoisted_138 = { key: 0 }
const _hoisted_139 = ["src"]

import { computed, onMounted, ref, watch } from 'vue'
import MyModal from '@/components/modal/MyModal.vue'
import { isNotificationsModalOpen, newNotification, viewNotification, checkLocalStorageNotification } from '@/global/states/ModalState'
import { storageUrl, user } from '@/global/states/GlobalState'
import { useAxios } from '@/api/axios'
import DocumentStatusEnum, { documentStatusTranslations, documentStatusDescriptions } from '@/enums/DocumentStatusEnum'
import ModelInterface, { ModelFileInterface } from '@/models/ModelInterface'
import ModelTypeEnum from '@/enums/ModelTypeEnum'
import ModelFileMimeTypeEnum from '@/enums/ModelFileMimeTypeEnum'
import { DocumentModel } from '@/models/DocumentModel'
import AlertModel from '@/models/AlertModel'
import NoteModel from '@/models/NoteModel'
import SpinnerLoader from '@/components/loader/SpinnerLoader.vue'

/* api */

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const axios = useAxios()
const documentStats = ref<{status: DocumentStatusEnum, count: number}[]>()
const models = ref<ModelInterface[]>()
const recentDocuments = ref<DocumentModel[]>()
const alert = ref<AlertModel>()
const todayNotes = ref<NoteModel[]>([])
const alertRemainingDays = computed(() => {
  if (!alert.value) return null

  const today = new Date()
  const todayDay = today.getDate()
  const limitDate = new Date(alert.value.limit_date)
  const limitDay = limitDate.getDate()

  let remainingDays = limitDay - todayDay
  if (remainingDays < 0) {
    remainingDays += new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate()
  }

  let color = 'black'
  if (remainingDays <= 5) {
    color = 'red'
  } else if (remainingDays <= 10) {
    color = 'orange'
  }

  return { value: remainingDays, color }
})
const documentModels = computed(() => (models.value ?? []).filter((model) => model.type == ModelTypeEnum.DOCUMENT_MODEL))
const documentFlowModels = computed(() => (models.value ?? []).filter((model) => model.type == ModelTypeEnum.FLOW_MODEL))
const selectedModel = ref<ModelInterface>()
const isModelModalOpen = ref(false)
const selectedFilesSrc = ref<string[]>([])

async function loadSelectedModelFiles () {
  if (selectedModel.value?.files) {
    const sources = await Promise.all(
      selectedModel.value.files.map(async (file) => {
        return await visualizeFile(file as ModelFileInterface)
      })
    )
    selectedFilesSrc.value = sources
  }
}

async function visualizeFile (file: ModelFileInterface): Promise<string> {
  try {
    const response = await axios.get(`/api/models/get-file-content/${file.id}`, { responseType: 'blob' })
    return URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }))
  } catch (error) {
    console.error('Erro ao buscar o documento:', error)
    return ''
  }
}

watch(selectedModel, async () => {
  await loadSelectedModelFiles()
}, { deep: true, immediate: true })

/* Input search ref v-model */
const searchInput = ref<string>('')

/* Defines whether the alert is visible or not. */
const isAlertVisible = ref<boolean>(true)

/* Note alert state */
const isNoteAlertVisible = ref<boolean>(true)
const noteAlertNote = computed(() => todayNotes.value[0] ?? null)
const noteAlertRemainingDays = computed(() => {
  if (!noteAlertNote.value) return null
  const months = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
  const [year, month, day] = noteAlertNote.value.event_date.split('-').map(Number)
  const eventDate = new Date(year, month - 1, day)
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const remainingDays = Math.round((eventDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24))
  const isToday = remainingDays === 0
  let color = 'black'
  if (remainingDays <= 5) color = 'red'
  else if (remainingDays <= 10) color = 'orange'
  return { days: remainingDays, dayOfMonth: day, monthLabel: months[month - 1], color, isToday }
})

function stripHtml (html: string | null): string {
  if (!html) return ''
  return html.replace(/<[^>]*>/g, '').trim()
}

/* Variables passers */
const leftPasserModels = ref(false)
const rigthPasserModels = ref(true)
const leftPasserFluxo = ref(false)
const rigthPasserFluxo = ref(true)

/* Documents container ref. */
const contentModelsRef = ref<HTMLDivElement | null>(null)
const contentFluxoRef = ref<HTMLDivElement | null>(null)

/* Verify scroll */
const verifyScroll = () => {
  if (contentModelsRef.value) {
    leftPasserModels.value = !(contentModelsRef.value.scrollLeft == 0)
    rigthPasserModels.value = !(contentModelsRef.value.scrollLeft >= contentModelsRef.value.scrollWidth - contentModelsRef.value.clientWidth)
  }
  if (contentFluxoRef.value) {
    leftPasserFluxo.value = !(contentFluxoRef.value.scrollLeft == 0)
    rigthPasserFluxo.value = !(contentFluxoRef.value.scrollLeft >= contentFluxoRef.value.scrollWidth - contentFluxoRef.value.clientWidth)
  }
}

/* Document passer left. */
const scrollLeft = (content: string) => {
  if (content === 'models') {
    if (contentModelsRef.value) {
      contentModelsRef.value.scrollLeft -= 150
    }
  } else if (content === 'fluxo') {
    if (contentFluxoRef.value) {
      contentFluxoRef.value.scrollLeft -= 150
    }
  }
  verifyScroll()
}

/* Document passer right. */
const scrollRight = (content: string) => {
  if (content === 'models') {
    if (contentModelsRef.value) {
      contentModelsRef.value.scrollLeft += 150
      console.log(contentModelsRef.value.scrollLeft)
    }
  } else if (content === 'fluxo') {
    if (contentFluxoRef.value) {
      contentFluxoRef.value.scrollLeft += 150
      console.log(contentFluxoRef.value.scrollLeft)
    }
  }
  verifyScroll()
}

/* Container dragging method. */
let isDragging = false
let startX = 0
let scrollLeftDrag = 0

function startDragging (content: string, event: MouseEvent) {
  isDragging = true

  if (content === 'models') {
    startX = event.pageX - contentModelsRef.value!.offsetLeft
    scrollLeftDrag = contentModelsRef.value!.scrollLeft
  } else if (content === 'fluxo') {
    startX = event.pageX - contentFluxoRef.value!.offsetLeft
    scrollLeftDrag = contentFluxoRef.value!.scrollLeft
  }

  verifyScroll()
}

function dragging (content: string, event: MouseEvent) {
  if (!isDragging) return

  if (content === 'models') {
    const x = event.pageX - contentModelsRef.value!.offsetLeft
    const walk = (x - startX) * 0.8
          contentModelsRef.value!.scrollLeft = scrollLeftDrag - walk
  } else if (content === 'fluxo') {
    const x = event.pageX - contentFluxoRef.value!.offsetLeft
    const walk = (x - startX) * 0.8
          contentFluxoRef.value!.scrollLeft = scrollLeftDrag - walk
  }

  verifyScroll()
}

function stopDragging () {
  isDragging = false
  verifyScroll()
}

function getDashboardInfo () {
  axios.get('/api/dashboard/home')
    .then((res) => {
      alert.value = res.data.alert
      recentDocuments.value = res.data.documents
      models.value = res.data.models
      documentStats.value = res.data.stats
      todayNotes.value = res.data.todayNotes ?? []
      if (todayNotes.value.length > 0) {
        newNotification.value = true
      }
      verifyScroll()
    })
}

function downloadFiles (files: ModelFileInterface[]): void {
  files.forEach((file) => {
    axios.get(`/api/models/get-file-content/${file.id}`, { responseType: 'blob' })
      .then(response => {
        const url = URL.createObjectURL(new Blob([response.data]))

        const link = window.document.createElement('a')
        link.href = url
        link.setAttribute('download', file.name)
        link.style.display = 'none'
        window.document.body.appendChild(link)
        link.click()
        window.document.body.removeChild(link)
      })
      .catch(error => {
        console.error('Erro ao buscar o documento:', error)
      })
  })
}

onMounted(() => {
  getDashboardInfo()
  checkLocalStorageNotification();
})

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("section", null, [
        _createElementVNode("label", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass({typed: searchInput.value.length > 0}),
            autocomplete: "off",
            name: "search",
            id: "search",
            type: "text",
            placeholder: "Busque por data, número de ofício, título do documento",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchInput).value = $event)),
            onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$router.push({name: 'admin.results',  params: { search: searchInput.value }})), ["enter"]))
          }, null, 34), [
            [_vModelText, searchInput.value]
          ]),
          (searchInput.value.length == 0)
            ? (_openBlock(), _createElementBlock("svg", {
                key: 0,
                xmlns: "http://www.w3.org/2000/svg",
                width: "20",
                height: "20",
                viewBox: "0 0 20 20",
                fill: "none",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/admin/results')))
              }, _hoisted_4))
            : (_openBlock(), _createElementBlock("svg", {
                key: 1,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (searchInput.value = '')),
                xmlns: "http://www.w3.org/2000/svg",
                width: "20",
                height: "20",
                viewBox: "0 0 20 20",
                fill: "none"
              }, _hoisted_7)),
          _createElementVNode("span", {
            class: _normalizeClass(["indicative", {visible: searchInput.value.length > 0}])
          }, " Aperte ENTER para buscar ", 2)
        ])
      ]),
      _createElementVNode("section", null, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("h1", null, [
            _createTextVNode("Olá, "),
            _createElementVNode("strong", null, _toDisplayString(_unref(user).name), 1)
          ])
        ]),
        _createElementVNode("button", {
          onClick: _cache[4] || (_cache[4] = ($event: any) => {isNotificationsModalOpen.value = true; _unref(viewNotification)(true)})
        }, [
          _createElementVNode("figure", null, [
            (_openBlock(), _createElementBlock("svg", _hoisted_9, [
              _hoisted_10,
              _hoisted_11,
              _hoisted_12,
              (_unref(newNotification))
                ? (_openBlock(), _createElementBlock("circle", _hoisted_13))
                : _createCommentVNode("", true)
            ]))
          ])
        ]),
        _createElementVNode("div", {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push('/admin/profile'))),
          class: "profile",
          role: "img",
          "aria-label": "Foto de perfil do usuário"
        }, [
          (_unref(user).image)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _unref(storageUrl) + _unref(user).image,
                alt: "Foto de perfil do usuário"
              }, null, 8, _hoisted_14))
            : (_openBlock(), _createElementBlock("img", _hoisted_15))
        ])
      ])
    ]),
    (alert.value && alertRemainingDays.value && isAlertVisible.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["alert", alertRemainingDays.value?.color])
        }, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _hoisted_19,
            _createElementVNode("h1", null, _toDisplayString(alertRemainingDays.value.value), 1)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("h1", null, _toDisplayString(alert.value.title), 1),
            _createElementVNode("h2", null, _toDisplayString(alert.value.description), 1)
          ]),
          _createElementVNode("button", {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (isAlertVisible.value = false))
          }, _hoisted_22)
        ], 2))
      : _createCommentVNode("", true),
    (noteAlertNote.value && noteAlertRemainingDays.value && isNoteAlertVisible.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["note-alert", noteAlertRemainingDays.value?.color])
        }, [
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("span", null, _toDisplayString(noteAlertRemainingDays.value.isToday ? 'Hoje' : 'Faltam'), 1),
            _createElementVNode("span", null, _toDisplayString(noteAlertRemainingDays.value.monthLabel), 1),
            _createElementVNode("h1", null, _toDisplayString(noteAlertRemainingDays.value.isToday ? noteAlertRemainingDays.value.dayOfMonth : noteAlertRemainingDays.value.days), 1)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("h1", null, _toDisplayString(noteAlertNote.value.title), 1),
            (noteAlertNote.value.description)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_26, _toDisplayString(stripHtml(noteAlertNote.value.description)), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", {
            class: "cta",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.push({ name: 'admin.notes.index' })))
          }, "VER NOTA >"),
          _createElementVNode("button", {
            class: "close",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (isNoteAlertVisible.value = false))
          }, _hoisted_28)
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("section", null, [
        _hoisted_30,
        _createElementVNode("div", _hoisted_31, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documentStats.value, (stat) => {
            return (_openBlock(), _createBlock(_component_RouterLink, {
              to: { name: 'admin.documents.index', query: { status: stat.status } },
              class: "item"
            }, {
              default: _withCtx(() => [
                _createElementVNode("h1", null, _toDisplayString(_unref(documentStatusTranslations)[stat.status]), 1),
                _createElementVNode("p", null, _toDisplayString(stat.count), 1),
                _createElementVNode("h2", null, _toDisplayString(_unref(documentStatusDescriptions)[stat.status]), 1)
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 256)),
          (!documentStats.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_36))
            : _createCommentVNode("", true),
          (!documentStats.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, _hoisted_41))
            : _createCommentVNode("", true),
          (!documentStats.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_42, _hoisted_46))
            : _createCommentVNode("", true),
          (!documentStats.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_47, _hoisted_51))
            : _createCommentVNode("", true),
          (!documentStats.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_52, _hoisted_56))
            : _createCommentVNode("", true),
          (!documentStats.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_57, _hoisted_61))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("section", _hoisted_62, [
        _hoisted_63,
        _createElementVNode("div", _hoisted_64, [
          (recentDocuments.value && recentDocuments.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recentDocuments.value, (document) => {
                  return (_openBlock(), _createElementBlock("div", {
                    onClick: ($event: any) => (_ctx.$router.push({ name: 'admin.documents.show', params: { id: document.id } })),
                    class: "item"
                  }, [
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("h1", null, _toDisplayString(document.responsibles[0].name.split(' ').map(word => word.charAt(0).toUpperCase()).join('')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_68, [
                      _createElementVNode("h2", null, [
                        _createTextVNode("Ofício "),
                        _createElementVNode("strong", null, "N° " + _toDisplayString(document.number), 1)
                      ]),
                      _createElementVNode("h1", null, _toDisplayString(document.title), 1),
                      (document.organizations.length)
                        ? (_openBlock(), _createElementBlock("h2", _hoisted_69, _toDisplayString(document.organizations[0].acronym), 1))
                        : _createCommentVNode("", true)
                    ])
                  ], 8, _hoisted_66))
                }), 256))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_70, _hoisted_74)),
          _hoisted_75
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_76, [
      (documentModels.value.length)
        ? (_openBlock(), _createElementBlock("section", _hoisted_77, [
            _createElementVNode("div", _hoisted_78, [
              _hoisted_79,
              _hoisted_80,
              _createVNode(_component_RouterLink, { to: '/admin/help' }, {
                default: _withCtx(() => [
                  _createTextVNode("Ver mais")
                ]),
                _: 1
              })
            ]),
            (leftPasserModels.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "button",
                  onMousedown: _cache[9] || (_cache[9] = ($event: any) => (scrollLeft('models')))
                }, _hoisted_82, 32))
              : (_openBlock(), _createElementBlock("div", _hoisted_83)),
            _createElementVNode("div", {
              class: "itens",
              ref_key: "contentModelsRef",
              ref: contentModelsRef,
              onMousedown: _cache[10] || (_cache[10] = ($event: any) => (startDragging('models', $event))),
              onMousemove: _cache[11] || (_cache[11] = ($event: any) => (dragging('models', $event))),
              onMouseup: stopDragging,
              onMouseleave: stopDragging
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documentModels.value, (model) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_84, [
                  (model.file_mime_type == _unref(ModelFileMimeTypeEnum).PDF)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_85))
                    : (model.file_mime_type == _unref(ModelFileMimeTypeEnum).WORD)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_86))
                      : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_87, [
                    _createElementVNode("h1", null, _toDisplayString(model.name), 1),
                    _createElementVNode("h2", null, _toDisplayString(model.description), 1),
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        class: "download",
                        onClick: ($event: any) => (downloadFiles(model.files as ModelFileInterface[]))
                      }, _hoisted_91, 8, _hoisted_88),
                      (model.file_mime_type !== _unref(ModelFileMimeTypeEnum).WORD)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "tooltip view",
                            onClick: ($event: any) => {selectedModel.value = model; isModelModalOpen.value = true}
                          }, _hoisted_94, 8, _hoisted_92))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              }), 256))
            ], 544),
            (rigthPasserModels.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "button",
                  onMousedown: _cache[12] || (_cache[12] = ($event: any) => (scrollRight('models')))
                }, _hoisted_96, 32))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_97, _hoisted_100)),
      _hoisted_101,
      (documentFlowModels.value.length)
        ? (_openBlock(), _createElementBlock("section", _hoisted_102, [
            _createElementVNode("div", _hoisted_103, [
              _hoisted_104,
              _hoisted_105,
              _createVNode(_component_RouterLink, { to: '/admin/help' }, {
                default: _withCtx(() => [
                  _createTextVNode("Ver mais")
                ]),
                _: 1
              })
            ]),
            (leftPasserFluxo.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "button",
                  onMousedown: _cache[13] || (_cache[13] = ($event: any) => (scrollLeft('fluxo')))
                }, _hoisted_107, 32))
              : (_openBlock(), _createElementBlock("div", _hoisted_108)),
            _createElementVNode("div", {
              class: "itens",
              ref_key: "contentFluxoRef",
              ref: contentFluxoRef,
              onMousedown: _cache[14] || (_cache[14] = ($event: any) => (startDragging('fluxo', $event))),
              onMousemove: _cache[15] || (_cache[15] = ($event: any) => (dragging('fluxo', $event))),
              onMouseup: stopDragging,
              onMouseleave: stopDragging
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documentFlowModels.value, (model) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_109, [
                  (model.file_mime_type == _unref(ModelFileMimeTypeEnum).PDF)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_110))
                    : (model.file_mime_type == _unref(ModelFileMimeTypeEnum).WORD)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_111))
                      : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_112, [
                    _createElementVNode("h1", null, _toDisplayString(model.name), 1),
                    _createElementVNode("h2", null, _toDisplayString(model.description), 1),
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        class: "download",
                        onClick: ($event: any) => (downloadFiles(model.files as ModelFileInterface[]))
                      }, _hoisted_116, 8, _hoisted_113),
                      (model.file_mime_type !== _unref(ModelFileMimeTypeEnum).WORD)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "tooltip view",
                            onClick: ($event: any) => {selectedModel.value = model; isModelModalOpen.value = true}
                          }, _hoisted_119, 8, _hoisted_117))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              }), 256))
            ], 544),
            (rigthPasserFluxo.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "button",
                  onMousedown: _cache[16] || (_cache[16] = ($event: any) => (scrollRight('fluxo')))
                }, _hoisted_121, 32))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_122, _hoisted_125))
    ]),
    _createElementVNode("nav", null, [
      _createElementVNode("div", {
        class: "tooltip",
        onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$router.push('/admin/create-documents')))
      }, _hoisted_127)
    ]),
    _createVNode(MyModal, {
      width: '400px',
      height: '481px',
      isOpen: _unref(isNotificationsModalOpen),
      class: _normalizeClass('notification'),
      toggleModal: (v) => isNotificationsModalOpen.value = v,
      zIndex: 100
    }, {
      default: _withCtx(() => [
        _hoisted_128,
        _createElementVNode("div", _hoisted_129, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(todayNotes.value, (note) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "item note",
              key: note.id,
              onClick: ($event: any) => {_ctx.$router.push({ name: 'admin.notes.edit', params: { id: note.id } }); isNotificationsModalOpen.value = false}
            }, [
              _hoisted_131,
              _createElementVNode("h1", null, _toDisplayString(note.title), 1),
              (note.description)
                ? (_openBlock(), _createElementBlock("h2", {
                    key: 0,
                    innerHTML: note.description
                  }, null, 8, _hoisted_132))
                : _createCommentVNode("", true),
              _createElementVNode("h2", _hoisted_133, _toDisplayString(note.event_date.split('-').reverse().join('/')), 1)
            ], 8, _hoisted_130))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recentDocuments.value, (document) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "item black",
              key: document.id
            }, [
              _createElementVNode("h2", null, _toDisplayString(new Date(document.created_at).toLocaleDateString()), 1),
              _createElementVNode("h2", null, [
                _createTextVNode("Ofício "),
                _createElementVNode("strong", null, "Nº " + _toDisplayString(document.number), 1)
              ]),
              _createElementVNode("h1", null, _toDisplayString(document.title), 1),
              _createElementVNode("h2", null, _toDisplayString(document.creator.organization?.acronym  ?? 'Sem organização'), 1)
            ]))
          }), 128)),
          (!todayNotes.value.length && !recentDocuments.value?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_134, _hoisted_137))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["isOpen", "toggleModal"]),
    (selectedModel.value)
      ? (_openBlock(), _createBlock(MyModal, {
          key: 2,
          isOpen: isModelModalOpen.value,
          class: _normalizeClass('docView'),
          toggleModal: (v) => isModelModalOpen.value = v,
          width: '80rem',
          height: '50rem',
          zIndex: 10
        }, {
          default: _withCtx(() => [
            (selectedFilesSrc.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedFilesSrc.value, (src) => {
                    return (_openBlock(), _createElementBlock("iframe", {
                      src: src,
                      width: "100%",
                      height: "100%"
                    }, null, 8, _hoisted_139))
                  }), 256))
                ]))
              : (selectedModel.value.files.length)
                ? (_openBlock(), _createBlock(SpinnerLoader, { key: 1 }))
                : _createCommentVNode("", true),
            _createElementVNode("p", null, _toDisplayString(selectedModel.value?.description), 1)
          ]),
          _: 1
        }, 8, ["isOpen", "toggleModal"]))
      : _createCommentVNode("", true)
  ]))
}
}

})